import React from "react";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import MaContainer from "../../Components/Common/container";
import { LuChevronRight } from "react-icons/lu";
import { MenuItem, TextField } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { IoChevronDownOutline } from "react-icons/io5";
import { useQuery } from "@apollo/client";
import { SINGLE_CONTINENTAL_PRODUCTS } from "../../Utils/Queries";
import ContinentalProductCard from "../../Components/Cards/continental-product-card";
import Loader from "../../Components/Common/Loader"
import EmptyData from "../../Components/Common/EmptyData";

const ContinentalFinds = () => {
  const { slug } = useParams();

  const { data, loading } = useQuery(SINGLE_CONTINENTAL_PRODUCTS, {
    variables: {
      slug,
    },
    skip: !slug,
  });

  const product_list = data?.getProductsByContinent?.items || [];

  return (
    <div>
      <Navbar />

      <MaContainer>
        <div className="pt-10">
          <div className="flex items-center gap-x-3">
            <Link to="/">
              <span className="text-[14px] text-[#727272]">Home</span>
            </Link>
            <LuChevronRight className="text-[#71747E] text-[12px]" />
            <Link to="/#continentalFinds">
            <span className="text-[14px] text-[#727272]">
              Continental Finds
            </span>
            </Link>
            <LuChevronRight className="text-[#71747E] text-[12px]" />
            <span className="text-[14px] text-[#353535] capitalize">
              {slug}
            </span>
          </div>

          <h1 className="mt-4 capitalize text-[28px] font-bold leading-tight text-[#1a1a1a] md:text-[32px]">
            {slug?.replace(/-/g, " ")}
          </h1>
          {/* FILTER SECTION */}
          {/* <div className="mt-6 flex flex-wrap items-center gap-3">
            <div className="w-[300px]">
              <TextField
                fullWidth
                sx={{
                  bgcolor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    fontWeight: 500,

                    fontSize: "14px",
                    fontFamily: "lato",

                    "& fieldset": {
                      borderColor: "#001A2B1A", // ✅ border color
                      borderRadius: "10px",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#001A2B1A",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#001A2B1A",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    // ✅ placeholder color
                    opacity: 1, // so MUI doesn’t fade it
                  },
                }}
                SelectProps={{
                  IconComponent: IoChevronDownOutline,
                }}
                select
                defaultValue={"Product Origin"}
              >
                <MenuItem value="Product Origin">Product Origin</MenuItem>
              </TextField>
            </div>
            <div className="w-[150px]">
              <TextField
                fullWidth
                sx={{
                  bgcolor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    fontWeight: 500,

                    fontSize: "14px",
                    fontFamily: "lato",

                    "& fieldset": {
                      borderColor: "#001A2B1A", // ✅ border color
                      borderRadius: "10px",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#001A2B1A",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#001A2B1A",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    // ✅ placeholder color
                    opacity: 1, // so MUI doesn’t fade it
                  },
                }}
                SelectProps={{
                  IconComponent: IoChevronDownOutline,
                }}
                select
                defaultValue={"Category"}
              >
                <MenuItem value="Category">Category</MenuItem>
              </TextField>
            </div>
            <div className="w-[150px]">
              <TextField
                fullWidth
                sx={{
                  bgcolor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    fontWeight: 500,

                    fontSize: "14px",
                    fontFamily: "lato",

                    "& fieldset": {
                      borderColor: "#001A2B1A", // ✅ border color
                      borderRadius: "10px",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#001A2B1A",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#001A2B1A",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    // ✅ placeholder color
                    opacity: 1, // so MUI doesn’t fade it
                  },
                }}
                SelectProps={{
                  IconComponent: IoChevronDownOutline,
                }}
                select
                defaultValue={"Price"}
              >
                <MenuItem value="Price">Price</MenuItem>
              </TextField>
            </div>
            <div className="w-[150px]">
              <TextField
                fullWidth
                sx={{
                  bgcolor: "#fff",
                  "& .MuiOutlinedInput-root": {
                    fontWeight: 500,

                    fontSize: "14px",
                    fontFamily: "lato",

                    "& fieldset": {
                      borderColor: "#001A2B1A", // ✅ border color
                      borderRadius: "10px",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#001A2B1A",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#001A2B1A",
                    },
                  },
                  "& .MuiInputBase-input::placeholder": {
                    // ✅ placeholder color
                    opacity: 1, // so MUI doesn’t fade it
                  },
                }}
                SelectProps={{
                  IconComponent: IoChevronDownOutline,
                }}
                select
                defaultValue={"Rating"}
              >
                <MenuItem value="Rating">Rating</MenuItem>
              </TextField>
            </div>
          </div> */}

          <section className="mt-10 pb-10" aria-label="Products">
            {loading ? (
              <>
            <Loader />
              <p className="text-[14px] text-[#727272]">Loading products…</p>
              </>
            ) : product_list.length === 0 ? (
              <EmptyData
                title="No products in this region yet."
                label="This is where you’ll see products."
              />
            ) : (
              <div className="grid grid-cols-2 items-stretch gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4 lg:gap-6">
                {product_list.map((product) => (
                  <div key={product._id} className="min-w-0">
                    <Link
                      to={`/product-view/${product._id}`}
                      className="block h-full cursor-pointer"
                    >
                      <ContinentalProductCard product={product} />
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      </MaContainer>

      <Footer />
    </div>
  );
};

export default ContinentalFinds;
